<style lang="less" scoped>
/deep/.el-tabs__nav>.el-tabs__item{padding: 0px !important;}
/deep/.el-tabs__item {width: 120px;font-size: 14px;padding: 0px;}
</style>

<template>
  <div>
    <el-tabs v-model="editableTabsValue" type="card" v-if='this.userData.groupid !== "8"'>
      <el-tab-pane label='我的咨询' name='1'>
        <LegalMy :userdata='userdata'></LegalMy>
      </el-tab-pane>
      <el-tab-pane label='其他咨询' name='2'>
        <LegalOther :userdata='userdata'></LegalOther>
      </el-tab-pane>
    </el-tabs>
    <el-tabs v-model="editableTabsValue" type="card" v-if='this.userData.groupid === "8"'>
      <el-tab-pane label='法律内容列表' name='1'>
        <LegalList :userdata='userdata'></LegalList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/**
 * 安进
 * 会员中心--法律管理页面
 */
import LegalMy from './LegalMy.vue'
import LegalOther from './LegalOther.vue'
import LegalList from './LegalList.vue'
import {mapState} from 'vuex'
export default {
  props: ['userData'],
  components: {
    LegalMy,
    LegalOther,
    LegalList
  },
  data()
  {
    return {
      editableTabsValue: '1',
      userdata: this.userData
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        this.editableTabsValue = nval
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/zxxx/FL/Flgl.vue